angular.module("tasks_reports")

    .controller("TasksReportsCtrl", ['$scope', '$rootScope', '$controller', '$state', 'Restangular', '$uibModal', 'modalService', '$filter',
        function ($scope, $rootScope, $controller, $state, Restangular, $uibModal, modalService, $filter) {

            $rootScope.title = $filter('translate')('tasks_reports.title');

            $scope.task_report = {
                user: {},
                event: {},
                task_status: [],
                late: false

            };
            $scope.showTasksReport = false;


            Restangular.all('Users').getList().then(function (persons) {
                $scope.selectPersons = persons;
                $scope.selectPersons.unshift({
                    id: null,
                    name: $filter('translate')('tasks_reports.all')
                });
                $scope.task_report.user = $scope.selectPersons[0];
            });

            /*Restangular.all('Events').getList({ is_template: false }).then(function (events) {
                $scope.selectEvents = events;
                $scope.selectEvents.unshift({
                    id: null,
                    name: $filter('translate')('tasks_reports.all')
                });
                $scope.task_report.event = $scope.selectEvents[0];
            });*/
            var options = {
                searchName: "",
                is_template: false
            };
            Restangular.all('Events/AllEvents').getList(options).then(function (events) {
                $scope.selectEvents = events;
                $scope.selectEvents.unshift({
                    id: null,
                    name: $filter('translate')('tasks_reports.all')
                });
                $scope.task_report.event = $scope.selectEvents[0];
            });

            Restangular.all('TasksStatus').getList({ entity_type: "events" }).then(function (status) {
                $scope.selectStatus = status;
            });

            $scope.generateReport = function () {

                $scope.showTasksReport = true;

                if (angular.isDefined($scope.gridOptionsTasks)) {
                    $scope.gridOptionsTasks.loadData(false);
                } else {
                    $scope.gridOptionsTasks = {
                        exporterMenuCsv: true,
                        enableGridMenu: true,
                        enableHiding: false,
                        gridMenuShowHideColumns: true,
                        paginationPageSizes: [5, 10, 25],
                        paginationPageSize: 15,
                        onRegisterApi: function (gridApi) {
                            this.gridApi = gridApi;
                        },
                        pdfTitle: $filter('translate')('tasks_reports.pdf_title'),
                        getFilterExternalDescription: function () {
                            var externalFilters = "";
                            if (angular.isDefined($scope.task_report.user) && $scope.task_report.user.id != null)
                                externalFilters += $filter('translate')('tasks_reports.person') + ": " + $scope.task_report.user.name + "\n";
                            if (angular.isDefined($scope.task_report.event) && $scope.task_report.event.id != null)
                                externalFilters += $filter('translate')('tasks_reports.event') + ": " + $scope.task_report.event.name + "\n";
                            if ($scope.task_report.task_status.length > 0) {
                                externalFilters += $filter('translate')('tasks_reports.status') + ": ";
                                angular.forEach($scope.task_report.task_status, function (status, idx) {
                                    externalFilters += status.name + ", ";
                                });
                                externalFilters = externalFilters.substring(0, externalFilters.length - 2) + "\n";
                            }
                            if (angular.isDefined($scope.task_report.task_status) && $scope.task_report.task_status.id != null)
                                externalFilters += $filter('translate')('tasks_reports.status') + ": " + $scope.task_report.task_status.name + "\n";

                            if ($scope.task_report.late)
                                externalFilters += $filter('translate')('tasks_reports.show_only_late') + "\n";
                            if ($scope.task_report.date_from != null && $scope.task_report.date_from != "") {
                                var fecha = $scope.task_report.date_from;
                                externalFilters += "\n" + $filter('translate')('tasks_reports.date_from') + ": " + fecha.getDate() + "/" + fecha.getMonth() + "/" + fecha.getFullYear() + " " + fecha.getHours() + ":" + fecha.getMinutes();
                            }
                            if ($scope.task_report.date_to != null && $scope.task_report.date_to != "") {
                                var fecha = $scope.task_report.date_to;
                                externalFilters += "\n" + $filter('translate')('tasks_reports.date_to') + ": " + fecha.getDate() + "/" + fecha.getMonth() + "/" + fecha.getFullYear() + " " + fecha.getHours() + ":" + fecha.getMinutes();
                            }

                            return externalFilters;
                        },
                        columnDefs: [
                          {
                              name: 'date_from', displayName: $filter('translate')('tasks_reports.date_from'), type: 'date', cellFilter: ' toLocalDate |date:\'dd/MM/yyyy HH:mm\'',
                              enableFiltering: false,
                              customFormatFn: function (value) {
                                  if (value != null) {
                                      var fecha = new Date(value);
                                      return $filter('date')(fecha, 'dd/MM/yyyy HH:mm');
                                  }
                                  return "";
                              },
                          },
                          {
                              name: 'date_to', displayName: $filter('translate')('tasks_reports.date_to'), type: 'date', cellFilter: ' toLocalDate |date:\'dd/MM/yyyy HH:mm\'',
                              enableFiltering: false,
                              customFormatFn: function (value) {
                                  if (value != null) {
                                      var fecha = new Date(value);
                                      return $filter('date')(fecha, 'dd/MM/yyyy HH:mm');
                                  }
                                  return "";
                              },
                          },
                          { name: 'title', displayName: $filter('translate')('tasks_reports.task'), enableHiding: false, enableGridMenu: false },
                          {
                              name: 'user_name', field: 'FK_events_tasks_users_events_tasks', displayName: $filter('translate')('tasks_reports.persons'), enableFiltering: false, suppressRemoveSort: true, enableSorting: false,
                              cellTemplate: '<div class="ui-grid-cell-contents">{{row.entity.FK_events_tasks_users_events_tasks | getNames}}</div></div>',
                              customFormatFn: function (value) {
                                  return $filter('getNames')(value);
                              },
                          },
                        { name: 'event_name', field: 'FK_events_tasks_events.name', displayName: $filter('translate')('tasks_reports.event'), enableGridMenu: false },
                        {
                            name: 'task_status', field: 'FK_events_tasks_tasks_status.name', displayName: $filter('translate')('tasks_reports.status'), enableGridMenu: false, enableSorting: false,
                            cellTemplate: '<div class="ui-grid-cell-contents" ng-if="row.entity.FK_events_tasks_tasks_status.code == \'PENDING\'"><label style="display: block; padding-top: 5px; padding-bottom: 5px;" class="label label-warning">{{row.entity.FK_events_tasks_tasks_status.name}}</label></div>' +
                                '<div class="ui-grid-cell-contents" ng-if="row.entity.FK_events_tasks_tasks_status.code == \'COMPLETED\'"><label style="display: block; padding-top: 5px; padding-bottom: 5px;" class="label label-primary">{{row.entity.FK_events_tasks_tasks_status.name}}</label></div>' +
                                '<div class="ui-grid-cell-contents" ng-if="row.entity.FK_events_tasks_tasks_status.code == \'CANCELED\'"><label style="display: block; padding-top: 5px; padding-bottom: 5px;" class="label label-danger">{{row.entity.FK_events_tasks_tasks_status.name}}</label></div>' +
                                '<div class="ui-grid-cell-contents" ng-if="row.entity.FK_events_tasks_tasks_status.code == \'IN_PROGRESS\'">' +
                                    '<div class="progress progress-striped" style="background-color: #e6e6e6;"><div ng-style="{\'width\': row.entity.work_progress + \'%\'}" aria-valuemax="100" aria-valuemin="0" aria-valuenow="{{row.entity.work_progress}}" role="progressbar" class="progress-bar progress-bar-warning"></div></div>' +
                                '</div>', 
                        },
                        { name: 'task_type', field: 'FK_events_tasks_tasks_types.name', displayName: $filter('translate')('tasks_reports.task_type'), enableGridMenu: false }
                        ],
                        getData: function (options) {
                            options.user_id = $scope.task_report.user.id;
                            options.event_id = $scope.task_report.event.id;
                            options.task_status_list = [];
                            angular.forEach($scope.task_report.task_status, function (status, idx) {
                                options.task_status_list.push(status.id);
                            });
                            options.date_from = $scope.task_report.date_from;
                            options.date_to = $scope.task_report.date_to;
                            options.late = $scope.task_report.late;
                            return Restangular.all('Reports/Tasks').getList(options);
                        }

                    };
                }
            }

        }])
.filter('getNames', function () {
    return function (items) {
        return items && items.map(function (item) {
            return item.users.name;
        }).join(', ');
    }
})

;